import styles from './app-bar.module.scss';
import MaterialAppBar from '@mui/material/AppBar';

/* eslint-disable-next-line */
export interface AppBarProps {
  children: any,
  // classes?: object,
  color?: 'default' | 'inherit' | 'primary' | 'secondary' | 'transparent',
  // enableColorOnDark?: boolean,
  position?: 'absolute' | 'fixed' | 'relative' | 'static' | 'sticky',
  sx?: any,
  className?: string
}

export function AppBar(props: AppBarProps) {
  return (
    <MaterialAppBar
      position={props.position}
      color={props.color}
      className={props.className}
      sx={props.sx}>
      {props.children}
    </MaterialAppBar>
  );
}

export default AppBar;